import React, { useState } from 'react'
import axios from 'axios'

import './Senha.css'

const Senha = () => {
    const [dados, setDados] = useState({user: localStorage.idJ})

    const updateField = (e) => {
        const { name, value } = e.target
        setDados(prevState => ({
            ...prevState,
            [name]: value
        })) 
    }

    const save = () => {
        const url = '/api/userJuridico/senha'
        axios.post(url, dados)
            .then(res => {
                alert(res.data)
                window.location = `/juridico`
            })
            .then()
            .catch(error => {
                console.log(error.response)
                alert(error.response.data)
            })
    }
    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-lock iconeBuscaPed"></i>
                SENHA
            </div>
            <div className="caixaSenha">
                <div className="labelSenha">
                    ALTERAR SENHA
                </div>
                <div className="formSenha">
                    <span className='spanFormSenha'>Senha atual</span>
                    <input type="password" className="inputSenha"
                        name="antiga"
                        onChange={e => updateField(e)} />
                    <span className='spanFormSenha'>Nova Senha</span>
                    <input type="password" className="inputSenha"
                        name="nova"
                        onChange={e => updateField(e)} />
                    <span className='spanFormSenha'>Repetir Senha</span>
                    <input type="password" className="inputSenha"
                        name="repetida"
                        onChange={e => updateField(e)} />
                </div>
                <button className="botaoSenha" onClick={() => save()} >SALVAR</button>
            </div>
        </React.Fragment>
    )
}

export default Senha